export default __webpack_public_path__ + "static/media/ZingProjectH1.c3917ce3.png";